import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  /* 
    When running the solution locally, React.Strict mode causes the App componet to reload twice. This results in
    the MSAL authentificaiton flow being triggered twice, causing a "BrowserAuthError: interaction_in_progress: 
    Interaction is currently in progress.". Comment out <React.StrictMode> to avoid the error being triggered.
    Note! React.StrictMode mode checks are run in development mode only; they do not impact the production build.
  */
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
